import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import './LabeledCheckbox.scss';

export const LabeledCheckbox = ({
    checked,
    onChange,
    text,
    value,
    disabled
}) => (
    <div className={'labeled-checkbox'}>
        <Checkbox
            checked={checked}
            disabled={disabled}
            onChange={() => onChange(value)}
            disableRipple
            color={'primary'}
        />
        <span>{text}</span>
    </div>
);
